import { useTranslate } from 'hooks/useTranslate';

import { usePartnerOperations } from '../context/PartnerOperationsContext';

const OperationsSectionHeader = () => {
  const { t } = useTranslate();

  const { data } = usePartnerOperations();

  return (
    <div className="nk-block-head">
      <div className="nk-block-head-content">
        <h4 className="nk-block-title">{t('PartnerTransactions')}</h4>
        <div className="nk-block-des">
          <p>
            {t('TransactionsInSocietyName', {
              societyName: data.societyName,
              partnerName: data.partner?.name || '',
            })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default OperationsSectionHeader;
